<template>
	<section class="pf-filter-links">
		<h2 class="pf-filter-links__title" :title="title" v-html="title"></h2>
		<ul class="pf-filter-links__list" ref="container">
			<li
				v-for="(item, name, i) in getItems"
				:key="name"
				class="pf-filter-links__item"
			>
				<a
					class="pf-filter-links__link"
					:href="getHref(name)"
					:title="item"
					v-html="item"
				></a>
			</li>
			<li v-if="showMoreBtn" class="pf-filter-links__item">
				<button
					class="pf-filter-links__show-more"
					@click.prevent="showAllItems"
				>
					<svg
						xmlns="http://www.w3.org/2000/svg"
						width="16"
						height="16"
						viewBox="0 0 16 16"
						fill="none"
					>
						<path
							fill-rule="evenodd"
							clip-rule="evenodd"
							d="M7.99935 9.33333C9.47211 9.33333 10.666 8.13943 10.666 6.66667C10.666 5.19391 9.47211 4 7.99935 4C6.52659 4 5.33268 5.19391 5.33268 6.66667C5.33268 8.13943 6.52659 9.33333 7.99935 9.33333ZM6.66602 6.66667C6.66602 7.40305 7.26297 8 7.99935 8C8.73573 8 9.33268 7.40305 9.33268 6.66667C9.33268 5.93029 8.73573 5.33333 7.99935 5.33333C7.26297 5.33333 6.66602 5.93029 6.66602 6.66667Z"
							fill="#252628"
						/>
						<path
							fill-rule="evenodd"
							clip-rule="evenodd"
							d="M6.64656 15.1569C5.92051 14.5788 5.19468 13.9255 4.51538 13.2085C2.53428 11.1173 1.33268 8.9144 1.33268 6.66667C1.33268 2.98477 4.31745 0 7.99935 0C11.6812 0 14.666 2.98477 14.666 6.66667C14.666 8.9144 13.4644 11.1173 11.4833 13.2085C10.804 13.9255 10.0782 14.5788 9.35213 15.1569C9.09761 15.3596 8.8608 15.5387 8.64749 15.6928C8.5175 15.7867 8.42278 15.8523 8.36915 15.888C8.14522 16.0373 7.85348 16.0373 7.62955 15.888C7.57592 15.8523 7.4812 15.7867 7.35121 15.6928C7.1379 15.5387 6.90108 15.3596 6.64656 15.1569ZM5.48332 12.2915C6.11652 12.9599 6.79693 13.5723 7.47713 14.1139C7.6628 14.2617 7.83781 14.3957 7.99935 14.5151C8.16089 14.3957 8.3359 14.2617 8.52156 14.1139C9.20176 13.5723 9.88218 12.9599 10.5154 12.2915C12.2843 10.4243 13.3327 8.50226 13.3327 6.66667C13.3327 3.72115 10.9449 1.33333 7.99935 1.33333C5.05383 1.33333 2.66602 3.72115 2.66602 6.66667C2.66602 8.50226 3.71441 10.4243 5.48332 12.2915Z"
							fill="#252628"
						/>
					</svg>
					<span v-html="showMoreText"></span>
				</button>
			</li>
		</ul>
	</section>
</template>

<script>
export default {
	name: 'FilterLinks',
	props: {
		title: {
			type: String,
			default: '',
		},
		items: {
			type: Object,
			default: () => {},
		},
	},
	data() {
		return {
			itemsCount: 10,
			showMoreBtn: false,
		}
	},
	computed: {
		isMobile() {
			return window.innerWidth < 768
		},

		isDesktop() {
			return window.innerWidth >= 1400
		},

		isDesktopSmall() {
			return window.innerWidth >= 1024 && window.innerWidth < 1400
		},

		getItems() {
			let items = {}

			Object.entries(this.items.values)
				.sort((a, b) => (a[1] > b[1] ? 1 : -1))
				.slice(0, this.itemsCount)
				.forEach(el => {
					items[el[0]] = this.items.values[el[0]]
				})

			return items
		},

		showMoreText() {
			let text = ''
			if (this.items.url) {
				text = 'Все субъекты'
			}

			return text
		},
	},
	methods: {
		getHref(name) {
			const url = window.location.pathname
			if (this.items.url) {
				return `${url}${this.items.url[name]}/`
			}

			return `${url}${name.toLowerCase()}/`
		},

		showAllItems() {
			this.itemsCount = Object.entries(this.items.values).length
			this.showMoreBtn = false
			setTimeout(() => this.setContainerHeight(), 100)
		},

		setContainerHeight() {
			if (this.isMobile) {
				this.$refs.container.style.height = `${this.$refs.container.scrollHeight}px`
				return
			}

			let columns = 3
			let rowHeight = 32

			if (this.isDesktopSmall) {
				columns = 4
			}

			if (this.isDesktop) {
				columns = 5
			}

			let rows =
				(Object.entries(this.getItems).length + (this.showMoreBtn ? 1 : 0)) /
				columns

			if (rows <= 3) {
				rows = 3
			}

			this.$refs.container.style.height = `${rows * rowHeight}px`
		},
	},
	mounted() {
		if (!this.isMobile) {
			this.itemsCount = 19
		}

		if (Object.entries(this.items.values).length > this.itemsCount) {
			this.showMoreBtn = true
		}

		setTimeout(() => this.setContainerHeight(), 0)
	},
}
</script>
